<template>
  <div class="risk-detail">
    <div class="risk-title"><i class="el-icon-warning-outline" /><div><span>一般关注</span><h3>{{ event.title }}</h3></div><b>{{ event.status }}</b></div>
    <dl><div><dt>所属项目</dt><dd>{{ event.projectName }}</dd></div><div><dt>发现时间</dt><dd>{{ event.time }}</dd></div></dl>
    <section><h4>事项现象</h4><p>{{ phenomenon }}</p></section><section class="risk-action"><h4>处置建议</h4><p>{{ recommendation }}</p></section>
    <ol><li class="active"><span>01</span>发现事项</li><li><span>02</span>值班核查</li><li><span>03</span>现场处置</li><li><span>04</span>复核归档</li></ol>
    <small>流程演示案例 · 不派发实际工单</small>
  </div>
</template>
<script>
export default {
  name: 'RiskDetail',
  props: { event: { type: Object, required: true } },
  computed: {
    phenomenon () { return (this.event.detail || '').replace(/^演示场景：/, '').split('建议')[0] },
    recommendation () { return (this.event.detail || '').split('建议').slice(1).join('建议') || '请值班人员核查并记录复核结果。' }
  }
}
</script>
<style lang="scss">
.asset-command .risk-detail {
  .risk-title{display:flex;align-items:center;gap:14px;>i{font-size:28px;color:#dfbf7e;background:#b3943420;padding:12px;border-radius:12px;}h3{font-size:18px;margin:6px 0 0;}span{font-size:11px;color:#c9b17d;}b{margin-left:auto;font-size:12px;font-weight:400;padding:5px 9px;border-radius:4px;background:#c2a64c20;color:#dcc58b;}}
  dl{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin:22px 0;padding:15px 0;border-top:1px solid #304b5b;border-bottom:1px solid #304b5b;dt{font-size:11px;color:#92adbe;}dd{margin:7px 0 0;font-size:14px;}}
  section{background:#0c2537;border-radius:6px;padding:16px;h4{font-size:13px;margin:0 0 9px;}p{color:#abc3d0;font-size:13px;line-height:1.8;margin:0;}}
  .risk-action{margin-top:10px;}
  ol{display:flex;list-style:none;padding:0;margin:22px 0;gap:10px;li{flex:1;color:#89a5b5;font-size:11px;border-top:2px solid #345164;padding-top:10px;}span{display:block;font-size:12px;margin-bottom:7px;}.active{color:#84d1be;border-color:#84d1be;}}small{font-size:11px;color:#8ca7b8;}
}
</style>
